import { ElementType, HtmlHTMLAttributes, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { PreviewableFile } from '@sib/types';
import { Button, cn } from '@sib/ui';
import { NoResults, Download } from '@sib/ui/icons';
import { downloadFileFromUrl } from '@spendbrain/utils/files';

interface NoTableDataProps
  extends PropsWithChildren,
    HtmlHTMLAttributes<HTMLDivElement> {
  Icon?: ElementType;
  title: string;
  description?: string;
  file?: PreviewableFile;
}

export const NoTableData = ({
  Icon,
  title,
  description,
  file,
  children,
  className,
}: NoTableDataProps) => {
  const { t } = useTranslation();

  const handleDownload = () => {
    if (file?.fileUrl) {
      downloadFileFromUrl(file.fileUrl, file.name);
    }
  };

  return (
    <div className="flex size-full items-center justify-center overflow-hidden rounded">
      <div
        className={cn(
          'relative box-border flex size-full flex-col items-center justify-center gap-y-7 rounded-sm py-20',
          className
        )}
      >
        {Icon ? (
          <Icon className="text-primary size-32" />
        ) : (
          <NoResults className="text-primary size-32" aria-hidden="true" />
        )}
        <div className="flex w-full flex-col items-center gap-y-4">
          <h3 className="text-primary text-center text-3xl">{title}</h3>
          {description && (
            <p className="text-primary max-w-md text-center text-xl font-normal">
              {description}
            </p>
          )}
        </div>
        {file?.fileUrl && (
          <div className="mt-4">
            <Button
              onClick={handleDownload}
              className="inline-flex items-center gap-2"
            >
              <Download className="size-4" />
              {t('download.title')}
            </Button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
